@if (!embedded) {
  <p-dialog
    [(visible)]="visible"
    [modal]="true"
    [appendTo]="'body'"
    [baseZIndex]="22000"
    [autoZIndex]="true"
    [style]="{width: 'min(94vw, 1600px)', 'max-height': '92vh', height: 'auto'}"
    [draggable]="false"
    [resizable]="false"
    [showHeader]="false"
    styleClass="weather-details-dialog"
    (onHide)="onClose()"
  >
    <ng-container *ngTemplateOutlet="weatherCoreTpl"></ng-container>
    @if (!isOnlyInfo) {
      <div class="weather-modal-footer">
        <div class="footer-input-section">
          <input
            type="text"
            [(ngModel)]="pointName"
            (ngModelChange)="pointNameChanged()"
            [placeholder]="pointNamePlaceholderKey | translate"
            class="footer-point-name-input"
          />
        </div>
        <div class="footer-buttons">
          <app-primary-button
            [title]="'Save'"
            (action)="onAddPoint()"
            [icon]="'pi pi-bookmark'"
            [loading]="isAddingPoint"
            [disable]="isAddingPoint || !canSave"
          ></app-primary-button>
          @if (pointData && pointData?.id) {
            <app-secondary-button
              [title]="'EXPORT'"
              (action)="onExport()"
              [icon]="'pi pi-upload'"
            ></app-secondary-button>
          }
          <button
            pButton
            type="button"
            [label]="'Close' | translate"
            class="close-btn"
            [disabled]="isAddingPoint"
            (click)="onClose()"
          ></button>
        </div>
      </div>
    }
  </p-dialog>
} @else {
  <div class="weather-details-embedded-panel">
    <ng-container *ngTemplateOutlet="weatherCoreTpl"></ng-container>
    @if (!isOnlyInfo) {
      <div class="weather-modal-footer">
        <div class="footer-input-section">
          <input
            type="text"
            [(ngModel)]="pointName"
            (ngModelChange)="pointNameChanged()"
            [placeholder]="pointNamePlaceholderKey | translate"
            class="footer-point-name-input"
          />
        </div>
        <div class="footer-buttons">
          <app-primary-button
            [title]="'Save'"
            (action)="onAddPoint()"
            [icon]="'pi pi-bookmark'"
            [loading]="isAddingPoint"
            [disable]="isAddingPoint || !canSave"
          ></app-primary-button>
          @if (pointData && pointData?.id) {
            <app-secondary-button
              [title]="'EXPORT'"
              (action)="onExport()"
              [icon]="'pi pi-upload'"
            ></app-secondary-button>
          }
          <button
            pButton
            type="button"
            [label]="'Close' | translate"
            class="close-btn"
            [disabled]="isAddingPoint"
            (click)="onClose()"
          ></button>
        </div>
      </div>
    }
  </div>
}

<ng-template #weatherCoreTpl>
  @if (!embedded) {
    <div class="weather-modal-header">
      <div class="location-info">
        <h2 class="location-name">
          {{ regionPathString }}
        </h2>
        <p class="coordinates" *ngIf="latitude !== null && longitude !== null">
          {{ latitude.toFixed(4) }}, {{ longitude.toFixed(4) }}
        </p>

        <p class="coordinates" *ngIf="polygonArea">
          {{ 'Area' | translate }}: {{ polygonArea }} {{ 'Ha' | translate }}
        </p>
      </div>
      <button type="button" class="close-button" (click)="onClose()">
        <i class="pi pi-times"></i>
      </button>
    </div>
  }

  <div class="weather-modal-tabs">
    <button
      class="tab-button"
      [class.active]="activeTab === 'info'"
      (click)="onTabChange('info')"
    >
      {{ 'BASIC_INFORMATION' | translate }}
    </button>
    <button
      class="tab-button"
      [class.active]="activeTab === 'graph'"
      (click)="onTabChange('graph')"
    >
      {{ 'CHART' | translate }}
    </button>
    <button
      class="tab-button"
      [class.active]="activeTab === 'summary'"
      (click)="onTabChange('summary')"
    >
      {{ 'SUMMARY_INDICATOR' | translate }}
    </button>

    @if (showContourTab) {
      <button
        class="tab-button"
        [class.active]="activeTab === 'contour'"
        (click)="onTabChange('contour')"
      >
        {{ 'Contour' | translate }}
      </button>
    }
  </div>

  <div class="weather-modal-content">
    @if (isLoadingStation) {
      <app-loading [loading]="isLoadingStation"></app-loading>
    } @else {
      <div class="content-with-sidebar">
        <app-weather-info-tab
          *ngIf="activeTab === 'info'"
          [latitude]="latitude"
          [longitude]="longitude"
          [dataSourceOptions]="dataSourceOptions"
          [date]="date"
        />

        <app-weather-graph-tab
          [dataSourceOptions]="dataSourceOptions"
          [latitude]="latitude"
          [longitude]="longitude"
          *ngIf="activeTab === 'graph'"
          [date]="date"
        />

        <app-weather-summary-tab
          *ngIf="activeTab === 'summary'"
          [latitude]="latitude"
          [longitude]="longitude"
          [dataSourceOptions]="dataSourceOptions"
        ></app-weather-summary-tab>

        @if (activeTab === 'contour' && showContourTab) {
          <div class="map-form-container">
            <mfs-old-map
              [height]="'100%'"
              [zoom]="16"
              [drawingMode]="true"
              [polygonJson]="polygonJsonWktInputFormat"
              [(geometry)]="polygonJsonWktOutputFormat"
              (geometryChange)="checkCanSave($event)"
              [isCenterMarker]="false"
              [(canSave)]="canSave"
              [satellite]="false"
              [isCenterControl]="false"
              [isSplitControl]="false"
              polygonColor="rgba(33, 150, 243, 0.2)"
            ></mfs-old-map>
          </div>
        }
      </div>
    }
  </div>
</ng-template>
